import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type StaticListFilter } from '../types/filters';

export const EXTERNALLY_OWNED_OPTIONS = [
  { value: 'true', label: 'True', limit: 1 },
  { value: 'false', label: 'False', limit: 1 },
];

export const externallyOwnedDefinition: FilterDefinition<StaticListFilter> = {
  id: FilterId.EXTERNALLY_OWNED,
  name: 'Externally Owned',
  selections: [],
  type: FilterType.STATIC_LIST,
  isVisible: true,
};

export const externallyOwnedHandler: FilterHandler<StaticListFilter> = {
  isActive(currentFilterState: StaticListFilter) {
    return currentFilterState.selections.length > 0;
  },
  isDefault(currentFilterState: StaticListFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(currentFilterState: StaticListFilter) {
    return { ...currentFilterState };
  },
};
